import React from 'react';
import { StatCard } from '../../../../ui/StatCard';
import { HydratedKpiStatBlock } from '../../../../../services/admin/cloudAgentTypes';
import { ICON_MAP, resolveIcon, tintSolid, tintBg } from './iconAllowlist';
import { BlockSourceNote } from './BlockSourceNote';

/** kpiStat → StatCard. */
export const KpiStatBlock: React.FC<{ block: HydratedKpiStatBlock }> = ({ block }) => {
  const Icon = resolveIcon(block.icon) ?? ICON_MAP.BarChart3;
  return (
    <div>
      <StatCard
        icon={<Icon className="w-6 h-6" style={{ color: tintSolid(block.tint) }} />}
        iconBg={tintBg(block.tint)}
        title={block.title ?? ''}
        value={block.data.value}
        valueType={block.data.valueType ?? 'number'}
        changeValue={block.data.changeValue}
        changeLabel={block.data.changeLabel}
      />
      <BlockSourceNote source={block.source} />
    </div>
  );
};
